import { render, staticRenderFns } from "./MaterialFile.vue?vue&type=template&id=11f05c32&"
import script from "@/scripts/MainMode/MainModeCourse/MainModeMaterial/components/MaterialFile.js?vue&type=script&lang=js&"
export * from "@/scripts/MainMode/MainModeCourse/MainModeMaterial/components/MaterialFile.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports